<template>
  <form
    @submit.prevent="search"
   class="padding-top-mobile-devices"
  >
    <v-autocomplete
      @item-clicked="search"
      @item-selected="search"
      :items="items"
      v-model="item"
      @keyup.enter.native="searchHai"
      placeholder="Search..."
      :wait="100"
      :min-len="1"
      :get-label="getLabel"
      :component-item="template"
      @update-items="updateItems"
      :auto-select-one-item="false"
      id="search"
    >
    </v-autocomplete>
  </form>
</template>

<script>
import SearchList from '@/components/widgets/search/SearchList'
import { productApi } from '@/services/ApiServices/productApi'
import { mapActions, mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('category', ['getCategoryData'])
	},
	data () {
		return {
			item: null,
			items: [],
			template: SearchList,
			keyWord: '',
			searchWord: ''
		}
	},
	watch: {
		$route: {
			handler (val) {
				if (val.name !== 'SearchResults') {
					this.item = null
					this.items = []
					// $('.v-autocomplete-input').val('');
					//
				}
			},
			deep: true
		}
	},
	methods: {
		...mapActions('productselected', ['setSelectedProductData']),
		...mapActions('category', ['setActiveCategories']),
		...mapActions('filters', [
			'updateKeyWord',
			'updatePriceRange',
			'updateFilterApplied'
		]),
		searchHai () {
			if (!(this.item && this.item.parent_name)) {
				this.item = {
					search_name: this.searchWord,
					is_a_category: false
				}
			}
			this.search()
		},
		search () {
			// const a =
			this.getLabel()
			if (!this.item) {
				// if (this.items.length > 0) {
				//   this.item = this.items[0];
				// }
			}
			if (!this.item) {
				this.setSelectedProductData([])
				this.setActiveCategories([])
				// this.updateFilterApplied(false);
				return false
			}

			this.updateKeyWord(JSON.parse(JSON.stringify(this.item)))

			const name = this.item.search_name
			this.$router.push({
				path: '/search-results',
				query: {
					search_name: name,
					display_text: `${name.length > 20 ? `${name.substr(0, 15)}...` : name}`,
					category_id: this.item.category_id,
					is_a_category: this.item.is_a_category
				}
			})
			// productApi.getSearchProducts(this.item)
			//   .then((res) => {
			//     if (res) {

			//     }
			//   })
			//   .catch((e) => {
			//
			//   });
		},
		getLabel (item) {
			if (item) {
				return item.search_name
			}
			return item
		},
		updateItems (text) {
			if (text) {
				this.searchWord = text
				productApi
					.getSearchNames(text)
					.then((res) => {
						if (res) {
							this.items = res.data
						}
					})
					.catch((e) => {
						this.items = []
					})
			}
		},
		createElementSearchIcon () {
			const searchMarkup =
        '<div class="serach-icon"><svg class="svg-inline--fa fa-search fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="search" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg><!-- <i class="fas fa-search"></i> --></div>'
			const se = document.querySelectorAll('.v-autocomplete-input-group')
			let x = 0
			se.forEach(() => {
				se[x].insertAdjacentHTML('beforeend', searchMarkup)
				x += 1
			})
		}
	},
	mounted () {
		// setTimeout(() => {
		//   this.createElementSearchIcon();
		// }, 500);
	}
}
</script>
<style lang="scss">

</style>
